const MiscellaneousTabLayout = [
    {
        "groupId": 1,
        "label": "Serial Numbers & Crates Tracking",
        "fields": [
            {
                "name": "RF_SERIALNUMBERHANDLING",
                "tableName": "",
                "label": "Serial #",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": false,
            },
            {
                "name": "AUTOGENERATESERIALNUMBER",
                "tableName": "",
                "label": "Auto Serial #",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": false,
            },
            {
                "name": "USECRATE",
                "tableName": "",
                "label": "Use Crate",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": false,
            },
            {
                "name": "SHOWSERIALNOPOPUP",
                "tableName": "",
                "label": "Show Serial #",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": false,
            }  
        ]
    } ,{
        "groupId": 2,
        "label": "Miscellaneous",
        "fields": [
            {
                "name": "ALLOWITEMDETAILS",
                "tableName": "",
                "label": "Allow Items",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": false,
            } ,
            {
                "name": "SUBLOT_ALTERNATEIDMETHOD",
                "tableName": "",
                "label": "Alternate ID",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": false,
            } ,
            {
                "name": "SCREENTOTALS",
                "tableName": "",
                "label": "Screen Totals",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": false,
            }  ,
            {
                "name": "TRANSLOCWEIGHT",
                "tableName": "",
                "label": "Trans Loc Wt",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": false,
            } ,
            {
                "name": "ESITMATEDWEIGHT",
                "tableName": "",
                "label": "Estimated Wt",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": false,
            }  ,
            {
                "name": "GENERATEINSPECTION",
                "tableName": "",
                "label": "Inspection",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": false,
            }  
        ]
    } ,{
        "groupId": 3,
        "label": "Item Task Details",
        "fields": [
            {
                "name": "R_CAACTIVITY_UNLOADBY",
                "tableName": "",
                "label": "Unload By",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": false,
                
            },
            {
                "name": "R_CAACTIVITY_PUTAWAYBY",
                "tableName": "",
                "label": "Putaway By",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": false,
                
            } ,
            {
                "name": "R_CAACTIVITY_CHECKBY",
                "tableName": "",
                "label": "Check By",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": false,
                
            } ,
            {
                "name": "R_CAACTIVITY_PICKBY",
                "tableName": "",
                "label": "Pick By",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": false,
                
            } ,
            {
                "name": "R_CAACTIVITY_LOADBY",
                "tableName": "",
                "label": "Load By",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": false,
                
            }  ,
            {
                "name": "RFGROUP_PARTIALQTY",
                "tableName": "",
                "label": "RF Group When Partial Qty",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": false,
                 
            }  ,
            {
                "name": "RFGROUP_FULLQTY",
                "tableName": "",
                "label": "RF Group When Full Qty",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": false,
                 
            }   
        ]
    } ,{
        "groupId": 4,
        "label": "Item Task Details",
        "fields": [
            {
                "name": "UNLOADBYDescription",
                "tableName": "",
                "label": "Unload By Description",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "readOnly": true,
            }  
            ,
            {
                "name": "R_CAACTIVITY_PUTAWAYBY_Des",
                "tableName": "",
                "label": "Putaway By Description",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "readOnly": true,
            } ,
            {
                "name": "R_CAACTIVITY_CHECKBY_Des",
                "tableName": "",
                "label": "Check By Description",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "readOnly": true,
            } ,
            {
                "name": "R_CAACTIVITY_PICKBY_Des",
                "tableName": "",
                "label": "Pick By Description",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "readOnly": true,
            } ,
            {
                "name": "R_CAACTIVITY_LOADBY_Des",
                "tableName": "",
                "label": "Load By Description",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "readOnly": true,
            },
            {
                "name": "",
                "tableName": "",
                "label": "",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "readOnly": true,
            },
            {
                "name": "",
                "tableName": "",
                "label": "",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "readOnly": true,
            }
        ]
    },{
        "groupId": 5,
        "label": "Labor Tracking",
        "fields": [
            {
                "name": "WORKUNITUOM",
                "tableName": "",
                "label": "Work Unit UOM",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": false,
                 
            }  
        ]
    } ,{
        "groupId": 6,
        "label": "Dynamically Evaluated Charges",
        "fields": [
            {
                "name": "PROCESSDYNEVALCHARGES",
                "tableName": "",
                "label": "Dyn Chargs",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": false,
            }  
        ]
    } ,{
        "groupId": 7,
        "label": "Receipt Quantity",
        "fields": [
            {
                "name": "RECEIPTCOMMITORDEREDACTUAL",
                "tableName": "",
                "label": "Receipt Qty",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": false,
            }  
        ]
    } ,{
        "groupId": 8,
        "label": "Ownership Transfer",
        "fields": [
            {
                "name": "OTCREATEITEMFLAG",
                "tableName": "",
                "label": "Create Items",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": false,
            }  
        ]
    } ,{
        "groupId": 9,
        "label": "Validations",
        "fields": [
            {
                "name": "LOTCODEENTRYMETHOD",
                "tableName": "",
                "label": "Lot Entry",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": false,
            } ,{
                "name": "OVERSELLINGWARNING",
                "tableName": "",
                "label": "Over Sellings",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": false,
            },{
                "name": "SUBLOTVERIFICATION",
                "tableName": "",
                "label": "Sublot Verification",
                "type": "select",
                "options": [],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "acceptCustomValue": false,
            }  
        ]
    } 
];

export {
    MiscellaneousTabLayout,
    }
